"use client";

import React from "react";
import { Heart, ShieldCheck, Star, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Compassion",
  description: "We approach every individual with genuine warmth and empathy. Our care is rooted in understanding the unique emotional needs of those we serve.",
  icon: Heart
}, {
  title: "Integrity",
  description: "Honesty and transparency guide every interaction we have. We maintain the highest ethical standards to ensure your family's peace of mind.",
  icon: ShieldCheck
}, {
  title: "Excellence",
  description: "We strive for the highest quality in clinical care and support. Our team is dedicated to continuous improvement and professional mastery.",
  icon: Star
}, {
  title: "Respect",
  description: "Dignity is at the heart of our service for every client. We honor personal choices and cultural backgrounds in every care plan we create.",
  icon: Users
}];
export default function PourquoiBoxify() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224452" id="the-values-we-live-by" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-foreground">
            The Values We Live By
          </h2>
          <Separator className="w-24 h-1 bg-primary rounded-lg" />
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full bg-card border-border shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center text-center rounded-lg">
                  <CardHeader className="pt-10 pb-4 flex flex-col items-center gap-4">
                    <div className="p-4 rounded-lg bg-secondary text-secondary-foreground mb-2">
                      <Icon size={48} strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-xl md:text-2xl font-bold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pb-10 px-8">
                    <p className="font-default text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}